import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import { useSelector } from 'react-redux';
import MaintainerChargePointDetailView from '../../components/MaintainerChargePointDetailView';

MaintainerChargePointDetailScreen.propTypes = {};

function MaintainerChargePointDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeStationId = router.query?.chargeStationId;
  const chargePointId = router.query?.chargePointId;
  const { user } = useSelector((state) => state.auth);

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {chargeStationId
          ? UIHelper.buildBreadcrumb([
            {
              title: 'Danh sách trạm sạc',
              onPress: () => {
                router.navigate(AppRoute.stationList);
              },
            },
            {
              title: 'Chi tiết trạm sạc',
              onPress: () => {
                router.navigate(-1);
              },
            },
            { title: 'Chi tiết trụ sạc' },
          ])
          : UIHelper.buildBreadcrumb([
            {
              title: 'Danh sách trụ sạc',
              onPress: () => {
                router.navigate(AppRoute.pointList);
              },
            },
            { title: 'Chi tiết trụ sạc' },
          ])}
      </div>
      <div className="">
        <MaintainerChargePointDetailView chargePointId={chargePointId} />
      </div>
    </div>
  );
}

export default MaintainerChargePointDetailScreen;
